import { faBell, faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Header from './Header'
import DateTime from './Clock'

function MainTitle({
  title,
  subtitle = null,
  status = false,
  backButton = false,
  links = false,
  icon = false,
}) {
  const navigate = useNavigate()
  const [showInfo, setShowInfo] = useState(false)

  const goBack = () => {
    navigate(-1)
  }

  const toggleShowInfo = () => {
    setShowInfo((prevState) => !prevState)
  }

  return (
    <div className="font-bold text-2xl w-full border-b-2 border-b-[#DDCCDF] mb-4 text-portal-dark-blue">
      <div className="pb-2">
        <h1 className="flex items-center space-x-2">
          <span>{title}</span>
          {icon && (
            <span className="relative">
              <FontAwesomeIcon
                icon={faCircleInfo}
                className="text-black hover:cursor-pointer"
                data-popover-target="popover"
                onClick={toggleShowInfo}
              />
            </span>
          )}
        </h1>
        <span className="text-sm text-gray-500 mb-6">{subtitle ?? ''}</span>
      </div>
      {backButton && (
        <span
          className="inline-flex items-center text-slate-500 mt-1 cursor-pointer hover:text-slate-600"
          onClick={goBack}
        >
          <span className="text-sm ml-2">Go Back</span>
        </span>
      )}
    </div>
  )
}

export default MainTitle
